import {ArrowDown} from 'lucide-react'

const HERO_IMAGE = "https://static.lumi.new/e8/e8d36b6e2418e82c758d5cd57f6c4ec4.jpg"

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Pastoral farm landscape with cattle grazing at golden hour"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#283618]/80 via-[#283618]/60 to-[#283618]/90" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
        <div className="max-w-3xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#40916C]/30 backdrop-blur-sm border border-[#40916C]/40 rounded-full px-4 py-1.5 mb-6 opacity-0 animate-fade-in-up">
            <div className="w-2 h-2 rounded-full bg-[#B7E4C7] animate-pulse" />
            <span className="text-[#B7E4C7] text-xs sm:text-sm font-medium tracking-wide">
              Free Precision Livestock Tools
            </span>
          </div>

          {/* H1 — SEO keyword rich */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#FEFAE0] leading-tight opacity-0 animate-fade-in-up delay-100">
            Professional Cow &amp; Cattle{" "}
            <span className="text-[#D4A373]">Gestation Calculator</span>
          </h1>

          <p className="mt-5 sm:mt-6 text-base sm:text-lg lg:text-xl text-[#B7E4C7]/90 max-w-2xl mx-auto leading-relaxed opacity-0 animate-fade-in-up delay-200">
            The most accurate <strong>cattle gestation calculator</strong> for farmers and ranchers.
            Track your cow&apos;s pregnancy duration, predict the calving date, and manage your
            breeding cycle with confidence.
          </p>

          {/* CTA Buttons */}
          <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 opacity-0 animate-fade-in-up delay-300">
            <a
              href="#gestation-calculator"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#D4A373] hover:bg-[#c4935f] text-[#283618] font-bold text-base sm:text-lg px-8 py-4 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5"
            >
              Calculate Calving Date
              <ArrowDown className="w-5 h-5" />
            </a>
            <a
              href="#tools"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-[#FEFAE0] font-semibold text-base px-8 py-4 rounded-xl border border-white/20 transition-all duration-200"
            >
              Explore All Tools
            </a>
          </div>

          {/* Trust indicators */}
          <div className="mt-10 sm:mt-12 flex flex-wrap items-center justify-center gap-6 sm:gap-8 opacity-0 animate-fade-in-up delay-400">
            {[
              { value: "100%", label: "Free Forever" },
              { value: "4+", label: "Breed Presets" },
              { value: "283", label: "Avg Gestation Days" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl sm:text-2xl font-bold text-[#D4A373]">{stat.value}</div>
                <div className="text-xs sm:text-sm text-[#B7E4C7]/70 mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 60" fill="none" className="w-full">
          <path d="M0 60L60 50C120 40 240 20 360 15C480 10 600 20 720 25C840 30 960 30 1080 25C1200 20 1320 10 1380 5L1440 0V60H0Z" fill="#FEFAE0" />
        </svg>
      </div>
    </section>
  )
}
